module.exports = __webpack_public_path__ + "static/media/EDIT.b49bb9fc.svg";